import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber, PhoneAuthProvider, signInWithCredential } from "firebase/auth";
import FirebaseApp from "../Firebase";
import { Capacitor } from "@capacitor/core";
import OtpInput from "react18-input-otp";
import styled, { css } from "styled-components";
import withNav from "../utils/hoc/withNav";
import logo from "../assets/Logo.png";
import Page from "../components/Page";
import ToastService from "../services/ToastService";
import { IonLoading } from "@ionic/react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { PhoneNumberUtil } from "google-libphonenumber";
import UserService from "../services/UserService";
import Analytics, { TRACK_PAGE_CATEGORIES } from "../lib/anayltics";
import { bindActionCreators } from "@reduxjs/toolkit";
import { setUserData } from "../actions/UserActions";
import { connect } from "react-redux";

declare global {
	interface Window {
		recaptchaVerifier: any;
		confirmationResult: any;
	}
}

const INVALID_OTP_CODE = "auth/invalid-verification-code";

const FunctionalContainer = styled.div<any>`
	display: flex;
	flex-direction: column;
	${(props) =>
		props.hide &&
		css`
			pointer-events: none;
			display: none;
		`};
`;

const DisplayContainer = styled.div<any>`
	display: ${({ isActive }) => (isActive ? "contents" : "none")};
`;

const PageContainer = styled.div<any>`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 0 1.5rem;
	flex-grow: 1;
`;

const XookLogoContainer = styled.div`
	height: 19%;
	width: 100%;
	background: #ffcc00;
	padding: 0;
	display: flex;
`;

const Xook = styled.img`
	width: 16vh;
	height: 100%;
`;

const SignInTitle = styled.div`
	font-weight: 600;
	font-size: 25px;
	color: #e8e8e8;
	line-height: 19px;
	text-align: left;
`;

const SignInSubtitle = styled.div`
	margin-top: 0.5rem;
	font-weight: 400;
	font-size: 18px;
	line-height: 16px;
	text-align: left;
	color: #b6b6b6;
`;

const SmallSpace = styled.div`
	margin: 0.5rem 0 0 0;
`;

const Space = styled.div`
	margin: 2rem 0 0 0;
`;

const Row = styled.div<any>`
	display: flex;
	flex-direction: row;
	align-items: ${(props) => props.alignItems || "center"};
`;

const DisplayPhoneNumber = styled.span`
	color: #ffcc00;
`;

const ErrorMsg = styled.span`
	color: #f57676;
	font-size: 12px;
	margin-top: 1.25rem;
	height: 12px;
	text-align: left;
`;

const Separator = styled.div`
	margin-right: 8px;
`;

const OTPsentMessage = styled.span`
	color: rgba(182, 182, 182, 0.6);
	font-size: 14px;
	text-align: left;
	margin-top: 0.3rem;
`;

const ResendText = styled.div`
	color: #b6b6b6;
	margin-top: 20px;
	font-size: 14px;
	text-align: left;
`;
const ResendTimer = styled.span``;

const ResendCTA = styled.span`
	color: #ffcc00;
	font-weight: 400;
	font-size: 14px;
	margin-left: 10px;
`;

const CTA = styled.div`
	margin-top: 1.25rem;
	height: 39px;
	padding: 0 1rem;
	width: max-content;
	background: #f4c60a;
	color: #000;
	border-radius: 4px;
	font-weight: 600;
	font-size: 18px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-transform: uppercase;
`;

const Disclaimer = styled.div`
	color: rgba(182, 182, 182, 0.6);
	margin-top: 20px;
	font-size: min(3.077vw, 15px);
	text-align: left;
	line-height: 19px;
`;

const HighLightedLink2 = styled.a`
	color: #fff !important;
`;

const FadedContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem 0;
	height: 100%;
	width: 100%;
	background: #545454;
	padding: 2rem 0 0 1.5rem;
	height: 35%;
	margin-top: auto;
`;

const Message = styled.div`
	height: max-content;
	font-weight: 500;
	font-size: 4vh;
	width: min-content;
	line-height: 5vh;
	color: #e8e8e8;
	text-align: left;
	opacity: 0.1;
`;

const Line = styled.div`
	height: 5px;
	width: 46px;
	background: #ffcc00;
	opacity: 0.1;
`;

const PREFIX = "+";
const DEFAULT_COUNTRY = {
	name: "us",
	countryCode: "+1",
};

//TODO: Update to another library for better support.
function updateCountryCode(countryCode: any) {
	const flagDropdownElement = document.getElementsByClassName(
		"react-international-phone-country-selector-button__button-content"
	)?.[0];
	const countryCodeElement = document.getElementById("country-code");
	const arrowElement = document.getElementsByClassName("react-international-phone-country-selector-button__dropdown-arrow")?.[0];
	if (flagDropdownElement && arrowElement) {
		if (countryCodeElement) {
			countryCodeElement.innerHTML = PREFIX + countryCode;
		} else {
			const countryCodeChildElement = document.createElement("div");
			countryCodeChildElement.id = "country-code";
			countryCodeChildElement.classList.add("country-code-preview");
			countryCodeChildElement.innerHTML = PREFIX + countryCode;
			flagDropdownElement.insertBefore(countryCodeChildElement, arrowElement);
		}
	}
}

const Login: React.FC = (props: any) => {
	const { navigate, setUserData } = props;
	const [inputScreen, setInputScreen] = useState<boolean>(true);
	const [loading, setLoading] = useState<boolean>(false);
	const [phoneNumber, setPhoneNumber] = useState<string>("");
	const [phoneDisplay, setPhoneDisplayValue] = useState<string>("");
	const [countryCode, setCountryCode] = useState<any>(DEFAULT_COUNTRY.countryCode);
	const [otp, setOtp] = useState<string>();
	const [error, setError] = useState<string>();
	const [verificationId, setVeificationId] = useState<any>();
	const [redirectTo, setRedirectPath] = useState<string>("");
	const firebaseApp = FirebaseApp.getInstance();
	const auth = getAuth(firebaseApp);
	const waitTimer = useRef<any>();
	const [isTimerRunning, setIsTimerRunning] = useState(false);
	const TimerRef = useRef<any>();
	const [OTPRequestCount, setOTPReqCount] = useState(0);
	const maxResendOTPRequest = 1;
	const recaptchaContainer = useRef<any>();

	function onPageLoad() {
		Analytics.trackPage(TRACK_PAGE_CATEGORIES.PAGE_LOAD, "Login");
		const { from } = props.location?.state || {};
		from ? setRedirectPath(from) : setRedirectPath("/");
	}

	useEffect(() => {
		onPageLoad();
		return () => {
			stopTimer();
			window.recaptchaVerifier = null;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setError("");
	}, [inputScreen]);

	useLayoutEffect(() => {
		updateCountryCode(countryCode);
	}, [countryCode]);

	//TODO: Find more why this error comes when user logs out and logs in without reloading the page.
	// Error: reCAPTCHA client element has been removed: 0

	function setupRecaptcha() {
		return new RecaptchaVerifier(
			"recaptcha-container",
			{
				size: "invisible",
				callback: function (response?: any) {
					// alert("reCAPTCHA solved");
				},
				"expired-callback": function () {
					// alert("Response expired. Ask user to solve reCAPTCHA again.");
				},
			},
			auth
		);
	}

	function handlePhoneInput(value: any) {
		setError("");
		const { phone, display, countryCode } = value;
		setPhoneDisplayValue(`${PREFIX}${countryCode} ${display}`);
		setPhoneNumber(phone);
		setCountryCode(countryCode);
	}

	function handleOtpInput(value: any) {
		setOtp(value);
	}

	function validatePhoneNumber() {
		try {
			const phoneUtil = PhoneNumberUtil.getInstance();
			return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phoneNumber));
		} catch (error) {
			return false;
		}
	}

	function validateOTP() {
		if (otp && otp.match("\\d{6}")) {
			return true;
		}
		return false;
	}

	function signIn() {
		//Different flows for Web and Native
		Capacitor.isNativePlatform() ? signInNative() : signInWeb();
	}

	function signInWeb() {
		//Invalid Phone number check
		if (!validatePhoneNumber()) {
			setError("Invalid Phone Number");
			return;
		}

		setError("");
		setLoading(true);
		//Render Recaptcha
		if (!window.recaptchaVerifier) {
			window.recaptchaVerifier = setupRecaptcha();
		}
		signInWithPhoneNumber(auth, phoneNumber, window.recaptchaVerifier)
			.then((confirmationResult) => {
				//All Good go ahead and show OTP Screen and start Timer.
				window.confirmationResult = confirmationResult;
				setInputScreen(false);
				setError("");
				startTimer();
				setLoading(false);
			})
			.catch((error) => {
				//Show Error Message.
				console.log(error.message);
				setError("Something went wrong");
				setLoading(false);
				setOtp("");
			});
	}

	function signInNative() {
		if (!validatePhoneNumber()) {
			setError("Invalid Phone Number");
			return;
		}
		setLoading(true);
		//Recaptcha needed for verification
		let applicationVerifier = setupRecaptcha();
		//Send OTP
		const provider = new PhoneAuthProvider(auth);
		provider
			.verifyPhoneNumber(phoneNumber, applicationVerifier)
			.then((verificationId) => {
				//OTP sent Successfully
				setVeificationId(verificationId);
				setInputScreen(false);
				setError("");
				setLoading(false);
			})
			.catch((error) => {
				//Error in sending OTP
				setError(error.message);
				setLoading(false);
				setOtp("");
			});
	}

	function handleOTP() {
		//Different flows for Web and Native
		Capacitor.isNativePlatform() ? handleOTPNative() : handleOTPWeb();
	}

	async function handleOTPWeb() {
		if (!validateOTP()) {
			setError("Invalid OTP");
			return;
		}
		//Confirm OTP
		setLoading(true);
		try {
			await window.confirmationResult.confirm(otp);
			setError("");
			sendSignInRequest();
		} catch (error: any) {
			setLoading(false);
			console.log(error.code, error);
			switch (error.code) {
				case INVALID_OTP_CODE:
					setError("Invalid OTP");
					break;

				default:
					setError("Something Went Wrong");
					console.log(error);
			}
		}
	}

	function handleOTPNative() {
		//Check for invalid OTP
		if (!validateOTP) {
			setError("Invalid OTP");
			return;
		}
		setLoading(true);
		// Verify OTP
		const credential = PhoneAuthProvider.credential(verificationId || "", otp || "");
		signInWithCredential(auth, credential)
			.then((response) => {
				//Redirect User
				setError("");
				sendSignInRequest();
			})
			.catch((error) => {
				//Something wrong in validating OTP
				setLoading(false);
				//Check for Invalid OTP CODE
				if (error.code === INVALID_OTP_CODE) {
					setError("Invalid OTP");
				} else {
					setError("Something Went Wrong");
					console.log(error);
				}
			});
	}

	async function handlesignInError() {
		try {
			await auth.signOut();
		} catch (error) {
			//TODO:  Maybe handle this more gracefully?
			console.log(error);
		}
		ToastService.showToast("Sorry could not sign you in. Please try again later");
		setOtp("");
		setLoading(false);
		setInputScreen(true);
	}

	async function sendSignInRequest() {
		//Send SignIn Request to Backend for creating a Customer.
		const payload = {
			mobileNo: phoneNumber,
		};
		const response = await UserService.signIn(payload);
		const { data, error } = response;
		if (data) {
			const { isNewUser } = data;
			if (isNewUser) {
				navigate.push(`/onboard/allergens/info`);
				// setLoading(false);
				setUserData({ isNewUser: true, destinationAfterOnboard: redirectTo });
			} else {
				//Redirect user to the original page.
				navigate.push(redirectTo);
			}
		}
		if (error) {
			//Error flow
			handlesignInError();
		}
	}

	function handleResendOTP() {
		setOtp(undefined);
		Capacitor.isNativePlatform() ? resendOTPNative() : resendOTPWeb();
	}

	function resendOTPWeb() {
		//Constraint on max otp resend requests.
		if (OTPRequestCount > maxResendOTPRequest) {
			setError("Max OTP Requests Reached");
			return;
		}
		setOTPReqCount((prev) => prev + 1);
		signInWeb();
	}

	function resendOTPNative() {}

	//Resend OTP timer
	function startTimer() {
		let timerInterval = 10;
		setIsTimerRunning(true);
		waitTimer.current = setInterval(function () {
			if (timerInterval <= 0) {
				stopTimer();
			} else if (TimerRef.current) {
				TimerRef.current.innerHTML = " Resend in " + timerInterval + "s";
			} else {
				stopTimer();
			}
			timerInterval--;
		}, 1000);
	}

	//Stop Resend OTP Timer
	function stopTimer() {
		clearInterval(waitTimer.current);
		setIsTimerRunning(false);
	}

	// function resetRecaptcha() {
	// 	window.recaptchaVerifier.reset();
	// }

	function handlePhoneNumberEditIntent() {
		setOtp("")
		setInputScreen(true);
	}

	return (
		<Page padding={"0 0"}>
			<XookLogoContainer>
				<Xook src={logo} />
			</XookLogoContainer>
			<DisplayContainer isActive={inputScreen} >
				<PageContainer>
					<FunctionalContainer>
						<SignInTitle>Sign In to Continue</SignInTitle>
						<Space />
						<SignInSubtitle>Phone Number</SignInSubtitle>
						<SmallSpace />
						<PhoneInput
							disableCountryGuess
							autoFocus={true}
							disableDialCodeAndPrefix
							hideDropdown={false}
							defaultCountry={DEFAULT_COUNTRY.name}
							onChange={(phone, { inputValue, country }) =>
								handlePhoneInput({ phone, display: inputValue, countryCode: country.dialCode })
							}
							value={phoneNumber}
						/>
						<ErrorMsg>{error}</ErrorMsg>
						<CTA onClick={signIn}>GET CODE</CTA>
					</FunctionalContainer>
					<Disclaimer>
						By signing up, you acknowledge to have read and agreed to the
						<HighLightedLink2 href="https://xook.ai/policies/tos.html"> Terms and Conditions</HighLightedLink2> and{" "}
						<HighLightedLink2 href="https://xook.ai/policies/privacy.html"> Privacy Policy</HighLightedLink2> .
					</Disclaimer>
				</PageContainer>
				<FadedContainer>
					<Message>YOUR PERSONAL ROBOTIC CHEF.</Message>
					<Line />
				</FadedContainer>
			</DisplayContainer>
			<DisplayContainer isActive={!inputScreen} >
				<PageContainer>
					<FunctionalContainer hide={inputScreen}>
						<SignInTitle>Verify your mobile</SignInTitle>
						<Space />
						<SignInSubtitle>Enter your Verification Code </SignInSubtitle>
						<OTPsentMessage>
							{" "}
							Code sent to <DisplayPhoneNumber onClick={handlePhoneNumberEditIntent}>{phoneDisplay}</DisplayPhoneNumber>
						</OTPsentMessage>
						<SmallSpace />
						<Row>
							<OtpInput
								value={otp}
								onChange={handleOtpInput}
								numInputs={6}
								isInputNum={true}
								separator={<Separator />}
								inputStyle={"otp"}
							/>
						</Row>
						<ErrorMsg>{error}</ErrorMsg>
						<Row alignItems="flex-end">
							<CTA onClick={handleOTP}>Confirm</CTA>
						</Row>
						<ResendText>
							Don't have a code?
							{isTimerRunning ? (
								<ResendTimer ref={TimerRef}></ResendTimer>
							) : (
								<ResendCTA onClick={handleResendOTP}>Resend</ResendCTA>
							)}
						</ResendText>
					</FunctionalContainer>
				</PageContainer>
				<FadedContainer>
					<Message>FOOD COURT IN A BOX.</Message>
					<Line />
				</FadedContainer>
			</DisplayContainer>
			<div id="recaptcha-container" ref={recaptchaContainer}></div>
			<IonLoading isOpen={loading} message={""} spinner={"circular"} cssClass="my-custom-class" />
		</Page>
	);
};

const mapStateToProps = () => {};

const mapDispatchToProps = (dispatch: any) => ({
	...bindActionCreators(
		{
			setUserData,
		},
		dispatch
	),
});

export default connect(mapStateToProps, mapDispatchToProps)(withNav(Login));
